export const reorderList = <T>(startIndex: number, endIndex: number, list?: T[]): T[] => {
	const result = Array.from(list!);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);
	return result;
};
